import { render, staticRenderFns } from "./water-overview.vue?vue&type=template&id=0500ff57&scoped=true"
import script from "./water-overview.vue?vue&type=script&lang=js"
export * from "./water-overview.vue?vue&type=script&lang=js"
import style0 from "./water-overview.vue?vue&type=style&index=0&id=0500ff57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0500ff57",
  null
  
)

export default component.exports